$(function () {

    $('.cookie-banner-close').on('click', function () {
        $('.cookie-banner').remove();
        var date = new Date(Date.now() + 1000 * 60 * 60 * 24 * 365);
        document.cookie = 'cookie_banner=1; expires=' + date.toUTCString() + '; path=/'
    });

    $('.mobile-nav').on('click', function () {
        $('header').hasClass('open') ? $('header').removeClass('open') : $('header').addClass('open');
    });

    $('.main-nav-dynamic').on('click', function (e) {
        e.preventDefault();
        var splitUrl = $(this).attr('href').split('/');
        var id = splitUrl[splitUrl.length - 1];
        if($(id).length) $(document.body).animate({ 'scrollTop': $(id).offset().top }, 500);
        $('header').removeClass('open')
    })

    if ($('#offerPopUp')) $('#offerPopUp').modal('show');

    $('#ncalmaSlider').ncalmaSlider();

    window.addEventListener('scroll', handleHeader);

    $('.translate-img').translateImg();
});

function handleHeader() {
    var heightToggle = 200;
    if ($('header').hasClass('header-scrolled') && window.scrollY < heightToggle) {
        $('header').removeClass('header-scrolled');
        var imgSrc = $('header img.logo').attr('src').replace('ncalma-symbol-black.svg', 'ncalma-symbol.svg');
        $('header img.logo').attr('src', imgSrc);
    }
    if (!$('header').hasClass('header-scrolled') && window.scrollY > heightToggle) {
        $('header').addClass('header-scrolled');
        var imgSrc = $('header img.logo').attr('src').replace('ncalma-symbol.svg', 'ncalma-symbol-black.svg');
        $('header img.logo').attr('src', imgSrc);
    }

    var currentMenu;
    $('.home-element').each(function (index, element) {
        if ($(element).offset().top - 100 <= window.scrollY) currentMenu = $(element).attr('id');
    })
    $('*[data-id]').removeClass('active')
    $('*[data-id=' + currentMenu + ']').addClass('active')
}

$.fn.ncalmaSlider = function () {

    const menuItems = $(this).find('.ncalma-slider-menu li');
    const navItems = $(this).find('.ncalma-slider-nav li');
    const residentialElement = $(this).find('.ncalma-slider-residential');
    const hotelElement = $(this).find('.ncalma-slider-hotel');

    let typeElement = residentialElement;

    menuItems.on('click', function () {
        menuItems.removeClass('active');
        $(this).addClass('active');
        typeElement = residentialElement;
        if ($(this).data('type') == 'hotel') typeElement = hotelElement;
        residentialElement.hide();
        hotelElement.hide();
        typeElement.show();

        navItems.parent('.ncalma-slider-nav').show();
        const nbElemnts = typeElement.find('.ncalma-slider-element').length;
        if (nbElemnts < 3) navItems.parent('.ncalma-slider-nav').hide();

        $('.ncalma-slider-element-tmp').remove();
        if (nbElemnts >= 3) {
            for (let i = 0; i <= 4; i++) {
                typeElement.find('.ncalma-slider-element').each(function(){
                    const element = $(this).clone().addClass('ncalma-slider-element-tmp');
                    typeElement.find('.ncalma-slider-content').append(element);
                })
            }

            typeElement.find('.ncalma-slider-content').css({left: `-${10 * nbElemnts * 46}vw`})
        }
    });

    navItems.on('click', function () {
        let left = "-=40vw";
        if ($(this).data('nav') === 'left') left = "+=40vw";

        typeElement.find('.ncalma-slider-content').animate({ left })
    })

    menuItems.eq(0).trigger('click')
};

$.fn.translateImg = function () {
    window.addEventListener('scroll', () => {
        const offsetTop = $(this).offset().top;
        $(this).find('img').css({transform: `translateY(${(window.scrollY - offsetTop) / 2}px)`})
    })
}